import { AxiosStatic, AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';

export default class TransactionClassificationResource extends FBaseService {
  public async getAll() : Promise<Map<string, string>> {
    const response:AxiosResponse = await this.apiClient.get('/api/rcx/config/transaction-classifications');
    const classifications: { [key: string]: string } = response.data.data;
    const classificationMap:Map<string, string> = new Map<string, string>();

    Object.keys(classifications).forEach((key:string) => {
      classificationMap.set(key, classifications[key]);
    });

    return classificationMap;
  }
}
